module.exports = __webpack_public_path__ + "media/images/covers/foundation/st-andrews-college-logo-33cf793b49a15e4a1ac94b6d47580aff.png";